// @core/api/endpoints/webhook/list_event_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEventTypesResponse,
} from '../../../types/webhook';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/webhook';

/**
 * List available event types
 * Returns all event types that can be subscribed to via webhooks. Each event type includes its schema and deprecation status.
 * @public This endpoint does not require authentication
 */
export async function ListEventTypes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListEventTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/event-types`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListEventTypesResponse>(requestPath, { ...requestOptions, params });
}
